"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUIRED_PROPERTIES = exports.testManageAction = exports.testBoolean = exports.testDownloadFormat = exports.testNumber = exports.testDate = exports.testArray = exports.testString = void 0;

var _includes = _interopRequireDefault(require("lodash/includes"));

var _errors = require("./errors");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testString = function testString(test) {
  if (typeof test === 'string') {
    if (test.length < 256) {
      return test;
    }

    throw new _errors.PropertyLengthError(test);
  }

  return undefined;
};

exports.testString = testString;

var testArray = function testArray(test) {
  if (test.length > 10000) {
    throw new _errors.PropertyLengthError(test);
  }

  return Array.isArray(test) ? test : undefined;
};

exports.testArray = testArray;

var testDate = function testDate(test) {
  if (test instanceof Date) {
    return test.toISOString();
  }

  if (typeof test === 'string') {
    var regex = '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$';

    if (test.match(regex)) {
      return test;
    } else {
      var validDate = new Date(test);

      if (validDate instanceof Date && isFinite(validDate)) {
        return validDate.toISOString();
      }
    }
  }

  return undefined;
};

exports.testDate = testDate;

var testNumber = function testNumber(test) {
  return typeof test === 'number' ? test : undefined;
};

exports.testNumber = testNumber;

var testDownloadFormat = function testDownloadFormat(test) {
  var regex = '^\\.[^.]+$';
  if (test.match(regex)) return test; // else

  throw new Error("Invalid download format. '".concat(test, "' must contain only one dot (it must be at the start) and followed by one or more non-dot characters."));
};

exports.testDownloadFormat = testDownloadFormat;

var testBoolean = function testBoolean(test) {
  return typeof test === 'boolean' ? test : undefined;
};

exports.testBoolean = testBoolean;

var testManageAction = function testManageAction(test) {
  if (!(0, _includes.default)(_constants.MANAGE_ACTIONS, test)) {
    throw new _errors.UnrecognizedTypeError(test, _constants.MANAGE_ACTIONS);
  }

  return test;
};

exports.testManageAction = testManageAction;
var MANAGE_EVENTS = {
  'Saved Search': {
    Action: testManageAction,
    Title: testString,
    Criteria: testArray
  },
  'Email Alert': {
    Action: testManageAction,
    Title: testString,
    Criteria: testArray,
    Frequency: testNumber
  },
  'User Preferences': {
    Action: testManageAction,
    Preferences: testArray
  },
  Notifications: {}
};
var VIDEO_EVENTS = {
  Play: {
    Title: testString,
    'Video URL': testString,
    Duration: testNumber
  },
  Complete: {
    Title: testString,
    'Video URL': testString,
    Duration: testNumber
  }
};
var REGISTRATION_EVENTS = {
  'Registration Form': {
    Action: testString,
    url: testString
  },
  'Success Page': {
    Action: testString,
    url: testString
  },
  'Choose Group Form': {
    Action: testString,
    url: testString
  },
  'Error Page': {
    Action: testString,
    url: testString
  }
};
var VIEW_EVENTS = {
  Content: {
    'Content Unique Identifier': testString,
    Title: testString,
    Tags: testArray,
    Author: testString,
    'Display Date': testDate,
    'Content Type': testString,
    Slug: testString
  },
  'Data Record': {
    Source: testString,
    Tags: testArray,
    ID: function ID(test) {
      return testNumber(test) || testString(test);
    }
  },
  'Data Record Collection': {
    Source: testString,
    Criteria: testArray,
    'Number Of Records': testNumber
  },
  Homepage: {},
  Sidebar: {
    Panel: testString
  },
  Dashboard: {
    Title: testString
  },
  Analysis: {
    Source: testString,
    Criteria: testArray
  },
  Support: {
    Title: testString
  },
  Project: {
    Title: testString,
    'Number of Blocks': testNumber
  },
  Share: {
    Action: testString
  },
  'Presentation Mode': {
    Slug: testString,
    User: testString,
    'Screen Resolution': testString
  },
  'Hero Banner': {
    Slug: testString,
    Title: testString,
    Tags: testArray,
    Author: testString,
    'Content Type': testString
  },
  'Exit to Other Mintel Website': {
    'Destination URL': testString,
    'Destination Product Name': testString,
    'Source Product Name': testString
  },
  'Related Content': {
    Slug: testString,
    Title: testString,
    Tags: testArray,
    Author: testString,
    'Content Type': testString
  },
  'Abandoned Product Tour': {
    'Final Step': testNumber
  },
  'Competed Product Tour': {},
  'Add to Presentation': {
    Title: testString,
    Type: testString,
    'Project Name': testString,
    'Number of Blocks in Project': testNumber
  },
  Favourite: {
    Title: testString,
    Tags: testArray,
    Author: testString,
    'Display Date': testDate,
    'Content Type': testString,
    Slug: testString,
    'Favourite List Name': testString
  },
  Scroll: {
    Title: testString,
    Tags: testArray,
    Author: testString,
    'Display Date': testDate,
    'Content Type': testString,
    Slug: testString,
    'Scroll Distance': testString,
    'Length of Piece in Blocks': testNumber
  },
  Notifications: {},
  'Copy Text': {}
};

var DOWNLOAD_EVENTS = function (obj) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    result[key] = {};
    Object.keys(obj[key]).forEach(function (innerKey) {
      result[key][innerKey] = obj[key][innerKey];
    });
    result[key].Format = testDownloadFormat;
  });
  return result;
}(VIEW_EVENTS);

var SEARCH_TYPES = {
  Quick: {
    Criteria: testArray
  },
  Advanced: {
    Criteria: testArray,
    Filter: function Filter(test) {
      return test;
    },
    Keyword: function Keyword(test) {
      return test;
    }
  },
  Refine: {
    Criteria: testArray,
    Filter: function Filter(test) {
      return test;
    },
    Keyword: function Keyword(test) {
      return test;
    }
  },
  Saved: {
    Criteria: testArray,
    Filter: function Filter(test) {
      return test;
    },
    Keyword: function Keyword(test) {
      return test;
    }
  },
  Search: {
    'Search Type': testString,
    Criteria: testArray,
    'Refine Criteria': testArray,
    'Used Text Search?': testBoolean,
    'Used Filter Search?': testBoolean
  }
};

var REQUIRED_PROPERTIES = function () {
  var events = {};
  events[_constants.EVENT_TYPES.View] = VIEW_EVENTS;
  events[_constants.EVENT_TYPES.Manage] = MANAGE_EVENTS;
  events[_constants.EVENT_TYPES.Search] = SEARCH_TYPES;
  events[_constants.EVENT_TYPES.Download] = DOWNLOAD_EVENTS;
  events[_constants.EVENT_TYPES.Engage] = VIEW_EVENTS;
  events[_constants.EVENT_TYPES.Navigate] = {};
  events[_constants.EVENT_TYPES.Video] = VIDEO_EVENTS;
  events[_constants.EVENT_TYPES.Navigate][_constants.EVENT_TYPES.Navigate] = {
    Action: testString,
    url: function url(test) {
      return test;
    }
  };
  events[_constants.EVENT_TYPES.Registration] = REGISTRATION_EVENTS;
  return events;
}();

exports.REQUIRED_PROPERTIES = REQUIRED_PROPERTIES;